import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserData } from './user.reducer';


export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Update Data': props<{ data: UserData }>(),
    'Copy RenderId': emptyProps
  },
});
